module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/Derrick-Larane-a47c508e675ab30b1a0d63da8eadf25c.png";